import React, { useEffect } from 'react';
import Chip from '@mui/material/Chip';

const colors = ['#FFD500', '#A96EFF', '#ffb17d', '#a7f200', '#6ED7FF'];
const colorcategory = {};

const useComponent = ({ categories = [] }) => {
  let counter = 0;
  categories.forEach((category, index) => {
    if (counter === colors.length) counter = 0;
    colorcategory[category] = colors[index];
  });

  const thereIsComponent = (data, index) => {
    if (index === 3) {
      return (
        <Chip
          label={data[index]}
          style={{
            background: `${colorcategory[data[index]]}`,
            color: 'white',
            fontWeight: 'bold',
          }}
        />
      );
    }
    return data[index];
  };

  return {
    thereIsComponent,
  };
};

export default useComponent;
